import tomSelectInit from "./components/tom-select";
import { LiveSocket } from "phoenix_live_view";
import { Socket, LongPoll } from "phoenix";
import Hooks from "./hooks";

import "./components/plausible.js";

// Include phoenix_html to handle method=PUT/DELETE in forms and buttons.
import "phoenix_html";

declare var window: any;

if (typeof window.queueMicrotask !== "function") {
  window.queueMicrotask = (callback: any) => {
    Promise.resolve()
      .then(callback)
      .catch((e) =>
        setTimeout(() => {
          throw e;
        }),
      );
  };
}

function handleDOMContentLoaded() {
  const forms = document.querySelectorAll(
    "form input, form select, form textarea",
  );

  forms.forEach((form) => {
    form.addEventListener("change", () => {
      form.classList.add("form-dirty");
    });

    window.addEventListener("beforeunload", () => {
      if (
        !form.classList.contains("ignore-changes") &&
        form.classList.contains("form-dirty")
      ) {
        return "You have unsaved changes, are you sure you want to discard them?";
      }
    });

    form.addEventListener("submit", () => {
      form.classList.remove("form-dirty");
    });
  });

  tomSelectInit();
}

function handleDocumentUnload() {
  window.currentView.unmount();
}

window.addEventListener("DOMContentLoaded", handleDOMContentLoaded, false);
window.addEventListener("unloaded", handleDocumentUnload, false);

const csrfToken = document
  .querySelector("meta[name='csrf-token']")!
  .getAttribute("content");

let liveSocket: any = new LiveSocket("/live", Socket, {
  dom: {
    onBeforeElUpdated(from: any, to: any) {
      // Ensure Select hooks are updated
      if (from.getAttribute("phx-hook") === "Select" && from.isEqualNode(to)) {
        from.classList.add("tomselected", "ts-hidden-accessible");
        from.blur();
      }

      return true;
    },
  },
  hooks: Hooks,
  params: { _csrf_token: csrfToken },
});

liveSocket.socket.onError(
  (_error: any, transport: any, establishedConnections: any) => {
    if (transport === WebSocket && establishedConnections === 0) {
      liveSocket.socket.replaceTransport(LongPoll);
      liveSocket.connect();
    }
  },
);

liveSocket.connect();
window.liveSocket = liveSocket;
